import PlaceOrder from './PlaceOrder'

export default PlaceOrder
